import React from 'react';
import WhyChooseData from '../../../data/whyChooseData';
import SingleWhyChoose from '../../../components/SingleWhyChoose/SingleWhyChoose';


const WhyChoose = () => {
   return (
      <>
         <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
            <defs>
               <clipPath id="why-choose-logo-clip" clipPathUnits="objectBoundingBox">
                  <path d="M0.3039,0.00176L0.0468,0.51638c-0.03451,0.06903,0.01573,0.15027,0.0929,0.15027h0.19982L0.67172,0.00176H0.3039Z" />
                  <path d="M0.69605,0.99824l0.2571,-0.51462c0.03451,-0.06903,-0.01573,-0.15027,-0.0929,-0.15027h-0.19982s-0.33219,0.66485,-0.33219,0.66485h0.36777Z" />
               </clipPath>
            </defs>
         </svg>
         <section className="features__area pt-115 pb-90">
            <div className="tw-container tw-mx-auto">
               {/* <div className="tw-flex tw-flex-wrap tw--mx-3 tw-items-end mb-60">
                  <div className="tw-w-full tw-px-3 lg:tw-w-7/12">
                     <div className="section__title section__title-h2 mb-0">
                        <span>Why Choose Harsoft?</span>
                        <h2>Elevate your digital <br /> experience with us.
                        </h2>
                     </div>
                  </div>
                  <div className="tw-w-full tw-px-3 lg:tw-w-5/12 tw-mt-6 lg:tw-mt-0">
                     <p className="mb-25">Harsoft Solutions is a full-stack software development company and web development company helping startups and enterprises build scalable web platforms, mobile apps, AI-powered products, and SaaS solutions from the ground up.</p>
                     <Link to="/ourStory" className="btn-more">
                        <span className="btn-text">What we do</span>
                        <span className="btn-icon" aria-hidden="true">
                           <ArrowUpRight size="16px" className="icon" />
                        </span>
                     </Link>
                  </div>
               </div> */}
               <div className="tw-flex tw-flex-wrap tw--mx-1">
                  {
                     WhyChooseData.map((item, index) => <SingleWhyChoose key={item.id} galleryItem={item} featured={index === 1} />)
                  }
               </div>
            </div>
         </section>
      </>
   );
};

export default WhyChoose;
